/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppConversationDataSchema = z.object({
	candidateId: z.string(),
	candidateName: z.string().nullable(),
	campaignId: z.string().nullable(),
	campaignTitle: z.string().nullable(),
	lastMessagePreview: z.string().nullable(),
	lastMessageAt: z.string().nullable(),
	lastDirection: z.string().nullable(),
	isAutomated: z.boolean(),
	needsReply: z.boolean(),
	unreadCount: z.number(),
	optedOut: z.boolean(),
	companySlug: z.string().nullable(),
})

export type WhatsAppConversationDataSchema = z.infer<typeof whatsAppConversationDataSchema>
